/*
1	Public
2	Registered
8	Super Users
10	ES Manager Group
11	ES Technician Group
12	ES Secretary Group
13	ES Technician Supervisor Group
14	ES Staff
15	ES Secretary Supervisor Group
*/

export default [
  {
    text: "Home",
    //level: [10, 12, 15, 11, 13],
    level: [10],
    path: "/home",
    icon: "home"
  },
  {
    text: "Πελάτες",
    level: [10, 12, 15],
    icon: "group",
    items: [
      {
        text: "Διαχείριση Πελατών",
        level: [10, 12, 15],
        path: '/ow-clients',
        icon: "isnotblank"
      }
    ]
  },
  {
    text: "Ραντεβού",
    level: [10, 12, 15, 11, 13],
    icon: "clock",
    items: [
      /*
      {
        text: "Διαχείριση Ραντεβού",
        path: "/ow-appointments",
        icon: "isnotblank"
      },
      */
      {
        text: 'Ημερολόγιο',
        level: [10, 12, 15, 11, 13],
        path: '/ow-appointment-calendar',
        icon: 'isnotblank'
      },
      {
        text: "Ημερήσιο Πρόγραμμα",
        level: [10, 12, 15, 11, 13],
        path: '/ow-view-rep-daily-programme',
        icon: "isnotblank"
      },
      {
        text: "Οργάνωση μήνα",
        path: "/ow-view-rep-monthly-programme",
        level: [10, 12, 15],
        icon: "isnotblank"
      }, 
      {
        text: 'Έλεγχος Ραντεβού',
        path: '/ow-view-appointments-check',
        level: [10, 12, 15],
        icon: 'isnotblank'
      },
    ]
  },
  {
    text: "Προβολή",
    level: [10, 12, 15],
    icon: "eyeopen",
    items: [
      /*
      {
        text: "Ραντεβού πελατών",
        path: '/ow-view-rep-clients-appointments',
        icon: "isnotblank"
      },
      */
      {
        text: "Πιστώσεις",
        level: [10, 12, 15],
        path: "/ow-view-rep-credits",
        icon: "isnotblank"
      },
      {
        text: "Παραστατικά",
        level: [10, 12, 15],
        path: "/ow-view-rep-credits-invoices",
        icon: "isnotblank"
      },
      {
        text: "Μηνύματα Τεχνικών",
        level: [10],
        path: "/ow-appointments-messages",
        icon: "isnotblank"
      },
    ]
    
  },

  {
    text: "Οικονομικά",
    level: [10],
    icon: "datatrending",
    items: [ 
        {
          text: 'Έξοδα',
          level: [10],
          path: '/ow-expenses',
          icon: 'isnotblank'
        }, 
        {
          text: 'Ταμείο',
          level: [10],
          path: '/ow-acc-cash-transactions',
          icon: 'folder'
        }
      ]
  },
  {
    text: "Εργαλεία",
    level: [10, 12, 15],
    icon: "toolbox",
    items: [
            {
              text: 'Εισαγωγή Πελατών από Excel',
              level: [10],
              path: '/ow-file-imports',
              icon: 'folder'
            }
      ]
  },
  {
    text: "Αναφορές",
    level: [10, 12, 15],
    icon: "print",
    items: [
        {
          text: 'Συγκεντρωτική Αναφορά Εισπράξεων Πελατών ανά Έτος και Μήνα',
          level: [10],
          path: '/ow-view-rep-client-monthly-summary',
          icon: 'isnotblank'
        },
        {
          text: 'Συγκεντρωτική Αναφορά Εισπράξεων ανά Έτος και Μήνα',
          level: [10],
          path: '/ow-view-rep-sales-monthly-yearly-summary',
          icon: 'isnotblank'
        }, 
        {
          text: 'Συγκεντρωτική Αναφορά Εργασιών ανά Έτος',
          level: [10],
          path: '/ow-view-rep-sales-yearly-summary',
          icon: 'isnotblank'
        }, 
        {
          text: 'Αναλυτική Αναφορά Νέων Πελατών ανά Έτος και Πηγή',
          level: [10],
          path: '/ow-view-rep-sales-peridical-forecast',
          icon: 'isnotblank'
        }, 
        {
          text: 'Αναλυτική Αναφορά Ραντεβού ανά Έτος και Πελάτη',
          level: [10],
          path: '/ow-view-rep-clients-appointments',
          icon: 'isnotblank'
        }, 
        {
          text: 'Αναλυτική Αναφορά Εισπράξεων ανά Συχνότητα ανά Έτος και Πηγή',
          level: [10],
          path: '/ow-view-rep-totalappfrequencyyearturnover',
          icon: 'isnotblank'
        },
        {
          text: 'Περιοδική Αναλυτική Αναφορά Εργασιών ανά Πηγή και Τύπο Πελάτη',
          level: [10, 12, 15],
          path: '/ow-view-rep-client-appointments-analysis',
          icon: 'isnotblank'
        }, 
        {
          text: 'Ημερήσια Αναλυτική Αναφορά Έξόδων Ανά Τεχνικό',
          level: [10],
          path: '/ow-view-expenses',
          icon: 'folder'
        },
        {
          text: 'Περιοδική Αναλυτική Αναφορά Εργασιών Ανά Τεχνικό',
          level: [10],
          path: '/ow-view-rep-appointments-per-technician',
          icon: 'isnotblank'
        }, 
        {
          text: 'Περιοδική Αναλυτική Αναφορά Εργασιών Ανά Είδος Εργασίας',
          level: [10],
          path: '/ow-view-rep-client-appointments-work-type-analysis',
          icon: 'folder'
        }, 
        {
          text: 'Περιοδική Αναλυτική Αναφορά Εξόδων Ανά Τεχνικό',
          level: [10],
          path: '/ow-view-rep-expenses-periodical',
          icon: 'folder'
        }, 
        {
          text: 'Περιοδική Αναλυτική Αναφορά Ταμείου Ανά Τεχνικό',
          level: [10],
          path: '/ow-view-rep-daily-sums',
          icon: 'folder'
        }
      
    ]
    /*
    items: [
      {
        text: "Αναφορά Εργασιών Ανά Πηγή Πελάτη",
        path: "/αναφορά-εργασιών-ανά-πηγή-πελάτη",
        icon: "isnotblank"
      },
      {
        text: "Αναφορά Εργασιών Ανά Είδος Εργασίας",
        path: "/αναφορά-εργασιών-ανά-είδος-εργασίας",
        icon: "isnotblank"
      },
      {
        text: "Αναφορά Εργασιών Ανά Τεχνικό",
        path: "/αναφορά-εργασιών-ανά-τεχνικό",
        icon: "isnotblank"
      },
      {
        text: "Ετήσια Αναφορά Ανά Μήνα",
        path: "/ετήσια-αναφορά-ανά-μήνα",
        icon: "isnotblank"
      },
      {
        text: "Αναφορά Πωλήσεων - Νέοι Πελάτες",
        path: "/αναφορά-πωλήσεων",
        icon: "isnotblank"
      }
    ]
    */
  },
  {
    text: "Ρυθμίσεις",
    level: [10],
    icon: "preferences",
    items: [
      {
        text: "Είδη Εργασιών",
        level: [10],
        path: "/ow-work-types",
        icon: "isnotblank"
      }, 
      {
        text: 'Τύποι Πελατών',
        level: [10],
        path: '/ow-client-types',
        icon: "isnotblank"
      }, 
      {
        text: 'Προτεραιότητες Ραντεβού',
        level: [10],
        path: '/ow-appointment-status',
        icon: 'isnotblank'
      },
      {
        text: "Χρήστες",
        level: [10],
        path: "/ow-users",
        icon: "isnotblank"
      }, 
      {
        text: 'Όμαδες Χρηστών',
        level: [10],
        path: '/ow-usergroups',
        icon: "isnotblank"
      }, 
      {
        text: 'Πηγές Πελατών',
        level: [10],
        path: '/ow-clients-sources',
        icon: 'isnotblank'
      }, 
      {
        text: 'Κατηγορίες Πελατών',
        level: [10],
        path: '/ow-clients-categories',
        icon: 'isnotblank'
      }, 
      {
        text: 'Τύποι Εξόδων',
        level: [10],
        path: '/ow-expense-types',
        icon: 'isnotblank'
      }, 
      {
        text: 'Αιτιολογίες Ακύρωσης Ραντεβού',
        level: [10],
        path: '/ow-appointment-cancellation-types',
        icon: 'isnotblank'
      },
    ]
  },
  ];